// salaryCategory.js (Service File)
import axiosInstance from "../Axios";

// Every active payhead category (Basic, HRA, PF, PT, etc.) from CI4's own
// pms_salary_categories master - same list the PHP payroll structure
// builder itself picks from.
function getActiveSalaryCategories() {
  try {
    return axiosInstance.get("/payroll/salary-categories/active");
  } catch (error) {
    console.log("Error while fetching active salary categories:", error);
    throw error;
  }
}

export { getActiveSalaryCategories };
